const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.WorkOrderServiceSimpleClient =
  function WorkOrderServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.createWorkOrder = this.createWorkOrder.bind(this);
    this.listWorkOrders = this.listWorkOrders.bind(this);
    this.listWorkOrderTypes = this.listWorkOrderTypes.bind(this);
    this.closeWorkOrder = this.closeWorkOrder.bind(this);
    this.completeWorkOrder = this.completeWorkOrder.bind(this);
    this.reopenWorkOrder = this.reopenWorkOrder.bind(this);
    this.deleteWorkOrder = this.deleteWorkOrder.bind(this);
    this.createWorkOrderNote = this.createWorkOrderNote.bind(this);
    this.deleteWorkOrderNote = this.deleteWorkOrderNote.bind(this);
    this.cancelWorkOrder = this.cancelWorkOrder.bind(this);
    this.editWorkOrder = this.editWorkOrder.bind(this);
    this.sendBackWorkOrder = this.sendBackWorkOrder.bind(this);
    this.pullWorkOrderSummary = this.pullWorkOrderSummary.bind(this);
    this.assignMaintenanceUserToWorkOrder =
      this.assignMaintenanceUserToWorkOrder.bind(this);
    this.pullMaintenanceUsers = this.pullMaintenanceUsers.bind(this);
    this.listWorkOrderNotes = this.listWorkOrderNotes.bind(this);
    this.pullWorkOrderReporters = this.pullWorkOrderReporters.bind(this);
    this.pullWorkOrderAssignedUsers =
      this.pullWorkOrderAssignedUsers.bind(this);
  };
const methodInfo_WorkOrderService_CreateWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.createWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_CreateWorkOrder
    );
  };
const methodInfo_WorkOrderService_ListWorkOrders =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrders",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListWorkOrdersRequest,
    imports.stronachgroup.first.racehorse360.ListWorkOrdersResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkOrdersResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.listWorkOrders =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListWorkOrdersRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrders",
      message,
      metadata || {},
      methodInfo_WorkOrderService_ListWorkOrders
    );
  };
const methodInfo_WorkOrderService_ListWorkOrderTypes =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderTypes",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest,
    imports.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkOrderTypesResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.listWorkOrderTypes =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListWorkOrderTypesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderTypes",
      message,
      metadata || {},
      methodInfo_WorkOrderService_ListWorkOrderTypes
    );
  };
const methodInfo_WorkOrderService_CloseWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CloseWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CloseWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.closeWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CloseWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CloseWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_CloseWorkOrder
    );
  };
const methodInfo_WorkOrderService_CompleteWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CompleteWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CompleteWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.completeWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CompleteWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CompleteWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_CompleteWorkOrder
    );
  };
const methodInfo_WorkOrderService_ReopenWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ReopenWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ReopenWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.reopenWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ReopenWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ReopenWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_ReopenWorkOrder
    );
  };
const methodInfo_WorkOrderService_DeleteWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.deleteWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_DeleteWorkOrder
    );
  };
const methodInfo_WorkOrderService_CreateWorkOrderNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrderNote",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest,
    imports.stronachgroup.first.racehorse360.WorkOrderNote,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrderNote.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.createWorkOrderNote =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateWorkOrderNoteRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CreateWorkOrderNote",
      message,
      metadata || {},
      methodInfo_WorkOrderService_CreateWorkOrderNote
    );
  };
const methodInfo_WorkOrderService_DeleteWorkOrderNote =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrderNote",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.deleteWorkOrderNote =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteWorkOrderNoteRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/DeleteWorkOrderNote",
      message,
      metadata || {},
      methodInfo_WorkOrderService_DeleteWorkOrderNote
    );
  };
const methodInfo_WorkOrderService_CancelWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/CancelWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CancelWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.cancelWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CancelWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/CancelWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_CancelWorkOrder
    );
  };
const methodInfo_WorkOrderService_EditWorkOrder = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.WorkOrderService/EditWorkOrder",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.EditWorkOrderRequest,
  imports.stronachgroup.first.racehorse360.WorkOrder,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.WorkOrder.decode
);
module.exports.WorkOrderServiceSimpleClient.prototype.editWorkOrder = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.EditWorkOrderRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.WorkOrderService/EditWorkOrder",
    message,
    metadata || {},
    methodInfo_WorkOrderService_EditWorkOrder
  );
};
const methodInfo_WorkOrderService_SendBackWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/SendBackWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.SendBackWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.sendBackWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.SendBackWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/SendBackWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_SendBackWorkOrder
    );
  };
const methodInfo_WorkOrderService_PullWorkOrderSummary =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderSummary",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest,
    imports.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullWorkOrderSummaryResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.pullWorkOrderSummary =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullWorkOrderSummaryRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderSummary",
      message,
      metadata || {},
      methodInfo_WorkOrderService_PullWorkOrderSummary
    );
  };
const methodInfo_WorkOrderService_AssignMaintenanceUserToWorkOrder =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/AssignMaintenanceUserToWorkOrder",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest,
    imports.stronachgroup.first.racehorse360.WorkOrder,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.WorkOrder.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.assignMaintenanceUserToWorkOrder =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AssignMaintenanceUserToWorkOrderRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/AssignMaintenanceUserToWorkOrder",
      message,
      metadata || {},
      methodInfo_WorkOrderService_AssignMaintenanceUserToWorkOrder
    );
  };
const methodInfo_WorkOrderService_PullMaintenanceUsers =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullMaintenanceUsers",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest,
    imports.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullMaintenanceUsersResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.pullMaintenanceUsers =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullMaintenanceUsersRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullMaintenanceUsers",
      message,
      metadata || {},
      methodInfo_WorkOrderService_PullMaintenanceUsers
    );
  };
const methodInfo_WorkOrderService_ListWorkOrderNotes =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderNotes",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest,
    imports.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListWorkOrderNotesResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.listWorkOrderNotes =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListWorkOrderNotesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/ListWorkOrderNotes",
      message,
      metadata || {},
      methodInfo_WorkOrderService_ListWorkOrderNotes
    );
  };
const methodInfo_WorkOrderService_PullWorkOrderReporters =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderReporters",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest,
    imports.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullWorkOrderReportersResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.pullWorkOrderReporters =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullWorkOrderReportersRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderReporters",
      message,
      metadata || {},
      methodInfo_WorkOrderService_PullWorkOrderReporters
    );
  };
const methodInfo_WorkOrderService_PullWorkOrderAssignedUsers =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderAssignedUsers",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest,
    imports.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersResponse.decode
  );
module.exports.WorkOrderServiceSimpleClient.prototype.pullWorkOrderAssignedUsers =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullWorkOrderAssignedUsersRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.WorkOrderService/PullWorkOrderAssignedUsers",
      message,
      metadata || {},
      methodInfo_WorkOrderService_PullWorkOrderAssignedUsers
    );
  };
